import { ReactElement } from "react";
import {
  Popover,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import CustomerPresencePopoverContent from "./Content";

type Props = Pick<PopoverProps, "placement"> & {
  children: ReactElement;
  isInPortal?: boolean;
  skuBrandOrderingPlatformId: UUID | null | undefined;
};

export default function CustomerPresencePopover({
  children,
  isInPortal,
  skuBrandOrderingPlatformId,
  ...rest
}: Props) {
  if (!skuBrandOrderingPlatformId) return children;

  const content = (
    <PopoverContent width="22rem">
      <CustomerPresencePopoverContent {...{ skuBrandOrderingPlatformId }} />
    </PopoverContent>
  );

  return (
    <Popover isLazy trigger="hover" openDelay={1000} {...rest}>
      <PopoverTrigger>{children}</PopoverTrigger>
      {isInPortal ? <Portal>{content}</Portal> : content}
    </Popover>
  );
}
